import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@app/app.config';
import { ApiListResponse, ApiResponse } from '@app/core/backend';
import { ApiClient } from '@eng-ds/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TipoOperatore, UDDItem, User } from '../user';

interface AppSorage {
  userInfo: User;
}

@Injectable()
export class UserService {
  private _appStorage: AppSorage;

  constructor(private apiClient: ApiClient, private http: HttpClient) {}

  saveUser(userData: User): void {
    const storageAuthUserInfo = JSON.parse(
      localStorage.getItem('auth_user_info')
    );
    this._appStorage = {
      ...storageAuthUserInfo,
      userInfo: userData
    };

    localStorage.setItem('auth_user_info', JSON.stringify(this._appStorage));
  }

  deleteUser(): void {
    // localStorage.removeItem('auth_user_info');
    localStorage.clear();
    this._appStorage = null;
  }

  get appStorage(): AppSorage {
    if (!this._appStorage) {
      const appToken: any = localStorage.getItem('auth_user_info');
      if (appToken) {
        this._appStorage = JSON.parse(appToken);
      }
    }
    return this._appStorage;
  }

  get user(): User {
    return this.appStorage?.userInfo || null;
  }

  get role(): TipoOperatore {
    return this.user?.TipoOperatore;
  }

  get isSuperRole(): boolean {
    return this.user.TipoOperatore === TipoOperatore.SUPER;
  }

  getUserData(): Observable<User> {
    return this.apiClient
      .request<ApiResponse<User>>('HOME_7', {
        ApplicationCod: AppConfig.applicationCode
      })
      .pipe(map((response) => response?.Body));
  }

  getUddList(): Observable<ApiListResponse<UDDItem>> {
    return this.apiClient.request('ACC_6');
  }
}
